/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { Tooltip } from "react-tippy";
import { RiExternalLinkLine } from "react-icons/ri";
import MsxIcons from "../../../Common/components/Icons/MsxIcons/MsxIcons";
import t from "../../../Common/utils/translation/translator";
import {
  selectCurrentAxisFilters,
  selectCurrentAxisId,
  selectCurrentFiltersStepperStep,
  setAxisFilters,
  setCurrentFiltersStepperStep,
  setShowAxisPopup
} from "../../../Retrofit/store/slices/retrofit";

const DevicesHeaderActions = ({ axis }) => {
  const dispatch = useDispatch();

  const currentAxisId = useSelector(selectCurrentAxisId);
  const currentFiltersStep = useSelector(selectCurrentFiltersStepperStep);
  const [initialFilters] = useState(useSelector(selectCurrentAxisFilters));

  // close the popup, apply the initial filters bcz the user didn't select a bundle
  const handleClosePopup = () => {
    // console.log("reset filters bcz the user didn't select a bundle");
    if (initialFilters !== undefined) {
      dispatch(setAxisFilters({ axisId: currentAxisId, filters: initialFilters }));
    }
    dispatch(setShowAxisPopup(false));
  };

  const previousAction = () => {
    // if current step is 1 then close the popup, else go to previous step
    if (currentFiltersStep === 1) {
      handleClosePopup();
    } else {
      dispatch(setCurrentFiltersStepperStep(1));
    }
  };

  const scrollToSelectedBundle = (event) => {
    event.preventDefault();

    const element = document.querySelector("#selected-bundle");

    element.scrollIntoView({ behavior: "smooth" });
  };

  // const eventsData = useSelector(selectEventsData);

  return (
    <div className="flex-1 flex items-center justify-between px-5">
      <div className="flex items-center space-x-1 text-xs" onClick={scrollToSelectedBundle}>
        {axis.bundle?.motorReference ? (
          <Tooltip
            position="bottom"
            theme="light"
            interactive
            size="small"
            arrow
            // eslint-disable-next-line prettier/prettier
            html={
              <div className="flex flex-col">
                {/* display motor, drive, gearbox and adaptation kit references */}
                {axis?.bundle?.motorReference && (
                  <div className="flex space-x-1">
                    <span className="font-semibold">{t("msizer.ui.motor")} :</span>

                    <a
                      className="hover:text-secondary flex items-center space-x-1"
                      target="_blank"
                      href={`https://www.se.com/ww/en/product/${axis?.bundle?.motorReference}`}
                      rel="noreferrer"
                    >
                      <RiExternalLinkLine />
                      <span>{axis?.bundle?.motorReference}</span>
                    </a>
                  </div>
                )}
                {axis?.bundle?.driveReference && (
                  <div className="flex space-x-1">
                    <span className="font-semibold">{t("msizer.ui.drive")} :</span>
                    <a
                      className="hover:text-secondary flex items-center space-x-1"
                      target="_blank"
                      href={`https://www.se.com/ww/en/product/${axis?.bundle?.driveReference}`}
                      rel="noreferrer"
                    >
                      <RiExternalLinkLine />
                      <span>{axis?.bundle?.driveReference}</span>
                    </a>
                  </div>
                )}
                {axis?.bundle?.gearboxReference && (
                  <div className="flex space-x-1">
                    <span className="font-semibold">{t("msizer.ui.gearbox")} :</span>
                    <a
                      className="hover:text-secondary flex items-center space-x-1"
                      target="_blank"
                      href={`https://www.se.com/ww/en/product/${axis?.bundle?.gearboxReference}`}
                      rel="noreferrer"
                    >
                      <RiExternalLinkLine />
                      <span>{axis?.bundle?.gearboxReference}</span>
                    </a>
                  </div>
                )}
                {axis?.bundle?.adaptationKitReference && (
                  <div className="flex space-x-1">
                    <span className="font-semibold">{t("msizer.ui.adaptation_kit")} :</span>
                    <a
                      className="hover:text-secondary flex items-center space-x-1"
                      target="_blank"
                      href={`https://www.se.com/ww/en/product/${axis?.bundle?.adaptationKitReference}`}
                      rel="noreferrer"
                    >
                      <RiExternalLinkLine />
                      <span>{axis?.bundle?.adaptationKitReference}</span>
                    </a>
                  </div>
                )}
              </div>
              // eslint-disable-next-line prettier/prettier
            }
          >
            <div className="flex items-center space-x-1 text-secondary">
              <MsxIcons data-tip data-for="bundle-references" name="info" size="nano" />
              <span className="font-semibold">{t("msizer.ui.select.bundle_selected")}</span>
            </div>
          </Tooltip>
        ) : (
          <>
            <div className="flex items-center space-x-1 text-gray-500">
              <MsxIcons name="info" size="nano" />
              <div className="font-semibold">{t("msizer.ui.select.no_bundle_selected")}</div>
            </div>
          </>
        )}
      </div>
      <div>
        {currentFiltersStep === 2 && (
          <div className="flex-1 flex justify-end">
            <qds-button
              size="small"
              onClick={() => {
                previousAction();
              }}
              text={t("msizer.ui.select.go_back_to_results")}
            ></qds-button>
          </div>
        )}
      </div>
    </div>
  );
};

DevicesHeaderActions.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  axis: PropTypes.any.isRequired
};

export default DevicesHeaderActions;
